module.exports = __webpack_public_path__ + "img/solution1.c9d4932c.png";